import { useMemo } from 'react'

import Add from '@/assets/icons/tasks/add-icon.svg'
import BigGroup from '@/assets/icons/tasks/big-group-icon.svg'
import Check from '@/assets/icons/tasks/check-icon.svg'
import Close from '@/assets/icons/tasks/close-icon.svg'
import Description from '@/assets/icons/tasks/description-icon.svg'
import DoneAll from '@/assets/icons/tasks/done-all-icon.svg'
import Emoji from '@/assets/icons/tasks/emoji-icon.svg'
import Favorite from '@/assets/icons/tasks/favorite-icon.svg'
import Flag from '@/assets/icons/tasks/flag-icon.svg'
import Group from '@/assets/icons/tasks/group-icon.svg'
import Help from '@/assets/icons/tasks/help-icon.svg'
import Home from '@/assets/icons/tasks/home-icon.svg'
import List from '@/assets/icons/tasks/list-icon.svg'
import Mail from '@/assets/icons/tasks/mail-icon.svg'
import Message from '@/assets/icons/tasks/message-icon.svg'
import Monitoring from '@/assets/icons/tasks/monitoring-icon.svg'
import OpenInNew from '@/assets/icons/tasks/open-in-new-icon.svg'
import PendingActions from '@/assets/icons/tasks/pending-actions-icon.svg'
import QueryStats from '@/assets/icons/tasks/query-stats-icon.svg'
import School from '@/assets/icons/tasks/school-icon.svg'
import Search from '@/assets/icons/tasks/search-icon.svg'
import Settings from '@/assets/icons/tasks/settings-icon.svg'
import Square from '@/assets/icons/tasks/square-icon.svg'
import Task from '@/assets/icons/tasks/task-icon.svg'
import Tracking from '@/assets/icons/tasks/tracking-icon.svg'
import Warning from '@/assets/icons/tasks/warning-icon.svg'
import Whatsapp from '@/assets/icons/tasks/whatsapp-icon.svg'

export const icons = {
  Home,
  Add,
  BigGroup,
  Check,
  Close,
  Description,
  DoneAll,
  Emoji,
  Favorite,
  Flag,
  Group,
  Help,
  List,
  Mail,
  Message,
  Monitoring,
  OpenInNew,
  PendingActions,
  QueryStats,
  School,
  Search,
  Settings,
  Square,
  Task,
  Tracking,
  Warning,
  Whatsapp,
} as const

export type IconType = keyof typeof icons

export function useIcon(
  icon: string | undefined | null,
  color?: string | null,
) {
  return useMemo(() => {
    const Component = icons[icon as IconType] ?? Close

    return (
      <Component
        key={icon}
        width={20}
        height={20}
        className="text-title"
        style={{ color: color ?? '#000000' }}
      />
    )
  }, [icon, color])
}
